import { Record } from "../fable_modules/fable-library.3.7.20/Types.js";
import { obj_type, equals, list_type, uint8_type, bool_type, record_type, option_type, class_type, string_type, int32_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { fromString as fromString_1, datetimeLocal, bool, list, decimal, string, int, object } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry } from "../fable_modules/fable-library.3.7.20/Util.js";
import { DateFormat_get_yyyy$002DMM$002Ddd, DateModule_parse } from "../Svea.Dry/Time.js";
import { some, defaultArg, bind } from "../fable_modules/fable-library.3.7.20/Option.js";
import { UrlKind, ValidatedUrlModule_create } from "../HttpV2.js";
import { printf, toText } from "../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../fable_modules/fable-library.3.7.20/Choice.js";
import { CaseStrategy } from "../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { ValidatedUrlModule_value, addClientReference, getCsrfEnabledRequest, Http_get_ExtraCoders } from "../HttpV2.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Http_send, Http_request, Http_method, Http_content, Http_withCredentials } from "../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod, BodyContent } from "../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { setPendingDirectInvoices, PendingDirectInvoice$reflection } from "../Redux/Reducers/DirectInvoiceReducer.js";
import { createThunk } from "../Redux/Redux.js";
import { LoadState$2 } from "../Global.js";
import { startImmediate } from "../fable_modules/fable-library.3.7.20/Async.js";

export class InvoiceFeeDTO extends Record {
    constructor(FeeNumber, Description, PeriodFrom, PeriodTo, ContractNumber) {
        super();
        this.FeeNumber = (FeeNumber | 0);
        this.Description = Description;
        this.PeriodFrom = PeriodFrom;
        this.PeriodTo = PeriodTo;
        this.ContractNumber = ContractNumber;
    }
}

export function InvoiceFeeDTO$reflection() {
    return record_type("Api.DirectInvoice.InvoiceFeeDTO", [], InvoiceFeeDTO, () => [["FeeNumber", int32_type], ["Description", string_type], ["PeriodFrom", class_type("System.DateOnly")], ["PeriodTo", option_type(class_type("System.DateOnly"))], ["ContractNumber", option_type(int32_type)]]);
}

export class CreateDirectInvoiceDTO extends Record {
    constructor(IgnoreMinimumAmount, NoInvoiceFee, CampaignCode, DirectDebitDistributed, BatchType, CreditInvoice, InvoiceFees) {
        super();
        this.IgnoreMinimumAmount = IgnoreMinimumAmount;
        this.NoInvoiceFee = NoInvoiceFee;
        this.CampaignCode = CampaignCode;
        this.DirectDebitDistributed = DirectDebitDistributed;
        this.BatchType = BatchType;
        this.CreditInvoice = CreditInvoice;
        this.InvoiceFees = InvoiceFees;
    }
}

export function CreateDirectInvoiceDTO$reflection() {
    return record_type("Api.DirectInvoice.CreateDirectInvoiceDTO", [], CreateDirectInvoiceDTO, () => [["IgnoreMinimumAmount", bool_type], ["NoInvoiceFee", bool_type], ["CampaignCode", option_type(string_type)], ["DirectDebitDistributed", bool_type], ["BatchType", uint8_type], ["CreditInvoice", bool_type], ["InvoiceFees", list_type(InvoiceFeeDTO$reflection())]]);
}

export class DirectInvoiceFee extends Record {
    constructor(FeeNr, Description, PeriodFrom, PeriodTo, AmountExclVat, AmountInclVat, ContractNr, Period) {
        super();
        this.FeeNr = (FeeNr | 0);
        this.Description = Description;
        this.PeriodFrom = PeriodFrom;
        this.PeriodTo = PeriodTo;
        this.AmountExclVat = AmountExclVat;
        this.AmountInclVat = AmountInclVat;
        this.ContractNr = ContractNr;
        this.Period = Period;
    }
}

export function DirectInvoiceFee$reflection() {
    return record_type("Api.DirectInvoice.DirectInvoiceFee", [], DirectInvoiceFee, () => [["FeeNr", int32_type], ["Description", string_type], ["PeriodFrom", class_type("System.DateOnly")], ["PeriodTo", option_type(class_type("System.DateOnly"))], ["AmountExclVat", class_type("System.Decimal")], ["AmountInclVat", class_type("System.Decimal")], ["ContractNr", option_type(int32_type)], ["Period", string_type]]);
}

export function DirectInvoiceFee_get_Decoder() {
    return (path_6) => ((v) => object((get$) => {
        let objectArg, objectArg_1, _arg, s, objectArg_2, option, objectArg_3, format_1, objectArg_4, objectArg_5, objectArg_6, objectArg_7;
        return new DirectInvoiceFee((objectArg = get$.Required, objectArg.Field("fee_number", uncurry(2, int))), (objectArg_1 = get$.Required, objectArg_1.Field("description", string)), (_arg = ((s = ((objectArg_2 = get$.Required, objectArg_2.Field("period_from", string))), DateModule_parse(DateFormat_get_yyyy$002DMM$002Ddd(), s))), (_arg == null) ? (() => {
            throw (new Error("[DirectInvoiceFee.PeriodFrom] Error: Cannot parse date"));
        })() : _arg), (option = ((objectArg_3 = get$.Optional, objectArg_3.Field("period_to", string))), bind((format_1 = DateFormat_get_yyyy$002DMM$002Ddd(), (s_1) => DateModule_parse(format_1, s_1)), option)), (objectArg_4 = get$.Required, objectArg_4.Field("amount_excl_vat", decimal)), (objectArg_5 = get$.Required, objectArg_5.Field("amount_incl_vat", decimal)), (objectArg_6 = get$.Optional, objectArg_6.Field("contract_number", uncurry(2, int))), (objectArg_7 = get$.Required, objectArg_7.Field("period", string)));
    }, path_6, v));
}

export function DirectInvoiceFee_get_ListDecoder() {
    const decoder = DirectInvoiceFee_get_Decoder();
    return (path) => ((value) => list(uncurry(2, decoder), path, value));
}

export class DirectInvoiceInfo extends Record {
    constructor(InvoiceDate, MinimumInvoiceAmountInclVat, CanDistributed, InvoiceFeeInclVat, Fees) {
        super();
        this.InvoiceDate = InvoiceDate;
        this.MinimumInvoiceAmountInclVat = MinimumInvoiceAmountInclVat;
        this.CanDistributed = CanDistributed;
        this.InvoiceFeeInclVat = InvoiceFeeInclVat;
        this.Fees = Fees;
    }
}

export function DirectInvoiceInfo$reflection() {
    return record_type("Api.DirectInvoice.DirectInvoiceInfo", [], DirectInvoiceInfo, () => [["InvoiceDate", class_type("System.DateTime")], ["MinimumInvoiceAmountInclVat", class_type("System.Decimal")], ["CanDistributed", bool_type], ["InvoiceFeeInclVat", class_type("System.Decimal")], ["Fees", list_type(DirectInvoiceFee$reflection())]]);
}

export function DirectInvoiceInfo_get_Decoder() {
    return (path_4) => ((v) => object((get$) => {
        let objectArg_4;
        let MinimumInvoiceAmountInclVat;
        const objectArg = get$.Required;
        MinimumInvoiceAmountInclVat = objectArg.Field("minimum_invoice_amount_incl_vat", decimal);
        let Fees;
        const arg_3 = DirectInvoiceFee_get_ListDecoder();
        const objectArg_1 = get$.Required;
        Fees = objectArg_1.Field("fees", uncurry(2, arg_3));
        let CanDistributed;
        const objectArg_2 = get$.Required;
        CanDistributed = objectArg_2.Field("can_distributed", bool);
        let InvoiceFeeInclVat;
        const objectArg_3 = get$.Required;
        InvoiceFeeInclVat = objectArg_3.Field("invoice_fee_incl_vat", decimal);
        return new DirectInvoiceInfo((objectArg_4 = get$.Required, objectArg_4.Field("invoice_date", datetimeLocal)), MinimumInvoiceAmountInclVat, CanDistributed, InvoiceFeeInclVat, Fees);
    }, path_4, v));
}

export class CreateInvoiceNoteDTO extends Record {
    constructor(note) {
        super();
        this.note = note;
    }
}

export function CreateInvoiceNoteDTO$reflection() {
    return record_type("Api.DirectInvoice.CreateInvoiceNoteDTO", [], CreateInvoiceNoteDTO, () => [["note", string_type]]);
}

export function createDirectInvoice(clientNr, invoiceeNr, directInvoice) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/direct_invoice/%i/%i"))(clientNr)(invoiceeNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(2), new CaseStrategy(0));
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_2, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(CreateDirectInvoiceDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(directInvoice));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function loadDirectInvoiceInfo(clientNr, invoiceeNr) {
    const url = toText(printf("/direct_invoice/%i/%i"))(clientNr)(invoiceeNr);
    let decoder_1;
    const decoder = DirectInvoiceInfo_get_Decoder();
    decoder_1 = ((value) => fromString_1(uncurry(2, decoder), value));
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, url));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const caseStrategy_1 = defaultArg(new CaseStrategy(2), new CaseStrategy(0));
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(DirectInvoiceInfo$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : decoder_1(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function createInvoiceNote(clientNr, invoiceeNr, invoiceNr, dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/invoice/%i/%i/%i/note"))(clientNr)(invoiceeNr)(invoiceNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_3, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(CreateInvoiceNoteDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export function loadPendingDirectInvoices(clientNr, invoiceeNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Invoice/PendingInstantInvoice/%i/%i/"))(clientNr)(invoiceeNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(PendingDirectInvoice$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(PendingDirectInvoice$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(PendingDirectInvoice$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function removeDirectInvoice(clientNr, invoiceeNr, invoiceeBatchId) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/direct_invoice/%i/%i/%i"))(clientNr)(invoiceeNr)(invoiceeBatchId)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const record = some({});
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_3 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(string_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(string_type, arg_3, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(obj_type), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(record));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(4), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                let response_1;
                return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(string_type, string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            });
        });
    }
}

export function Thunks_loadPendingDirectInvoicesThunk(clientNr, invoiceeNr) {
    return createThunk((dispatch) => ((getState) => {
        if (getState().DirectInvoice.PendingDirectInvoices.tag === 1) {
        }
        else {
            const dispatchSetPendingDirectInvoicesAction = (arg) => {
                dispatch(setPendingDirectInvoices(arg));
            };
            if (getState().DirectInvoice.PendingDirectInvoices.tag === 2) {
            }
            else {
                dispatchSetPendingDirectInvoicesAction(new LoadState$2(1));
            }
            startImmediate(singleton.Delay(() => singleton.Bind(loadPendingDirectInvoices(clientNr, invoiceeNr), (_arg) => {
                const result = _arg;
                dispatchSetPendingDirectInvoicesAction((result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, result.fields[0])));
                return singleton.Zero();
            })));
        }
    }));
}

